import { AllocationViewNextActionName } from '../constants';

export interface AllocationViewNextActionModel {
  available: boolean;
  action: AllocationViewNextActionName;
}
